import { CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { STYLE } from 'src/constants';

const { Title, Text } = Typography;

export const RecruitmentSucceededStep = () => {
  const { t } = useTranslation();

  return (
    <div className="center">
      <Title style={{ fontSize: 6 * STYLE.BASE_MARGIN }}>
        <CheckCircleOutlined className="green" />
      </Title>
      <Text>
        {t('Recruitment request succeeded')}
      </Text>
    </div>
  );
};
